// Mini Cart Discount Codes
let discountCode = "";
let miniCart = document.querySelector('#shopify-section-mini-cart');
miniCart?.addEventListener('input', (e) => {
    if(e.target.id == 'discount_code') {
        discountCode = e.target.value;
    }
  });
miniCart?.addEventListener('click', (e) => {
    if(e.target.id == 'apply_discount') {
        e.target.innerHTML = 'APPLYING';
        e.target.disabled = true;
        applyDiscount(discountCode);
    }
})
function applyDiscount(code) {
    fetch(`/discount/${code}`)
    .then(function() {
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            updates: {},
            }),
        });
    })
    .finally(function() {document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }),);})
    .catch(error => console.error('Error:', error));
};